import { AboutUsCard10, AboutUsCard11, AboutUsCard3, AboutUsCard5, AboutUsCard6, AboutUsCard7, AboutUsCard8, AboutUsCard9 } from "./Cards/AboutUs";
import { CategoryCard1, CategoryCard3 } from "./Cards/CategoryCards";
import { CountDownCard4 } from "./Cards/CountDownCard";
import { EventCard1 } from "./Cards/EventCards";
import { FooterCard1, FooterCard2, FooterCard3, FooterCard4 } from "./Cards/FooterCards";
import { HeroCard11, HeroCard13, HeroCard14 } from "./Cards/HeroCard";

const HomePageTemp =()=>{

    return(<>
    <div style={{marginTop:"90px"}}>
        <div>
    <HeroCard13 />
     <CategoryCard3 />
     
    <EventCard1 />
    <CountDownCard4 />
   
    <CategoryCard1 />
    
    <HeroCard14 />
    <AboutUsCard5 />
    <AboutUsCard7 />
    <FooterCard4 />
    </div>
    </div>
    <style>{`
    body{overflow-x:hidden;}`}</style>
    </>)
}
export default HomePageTemp;